<template>
  <div class="wizard">
    <!-- Индикация этапа -->
    <div class="progress-bar">
      <div class="back-step">
        <p v-if="currentStep >1" @click="backStep" class="back-step-text">←назад</p>
      </div>
      <div 
        :class="{'active': currentStep === step,'prev-step':step<currentStep }" 
        v-for="step in 6" :key="step">

        {{ step }}
      </div>

    </div>
    <!-- Этап 1: Выбор компании -->
    <div class="steps" v-if="currentStep === 1">
      <!-- Форма для выбора компании -->
      <p>Компания</p>
      <CompanyForm v-if="createCompany" @sendForm="sendForm"/>
      <div class="search-company" v-else>
        <div class="reactive-search">
          <reactiv-search 
          :items="searchList" 
          @changeItem="searchExecutors" 
          :model="'companies'"/>
          <p class="hover" @click="createCompany=true">Создать</p>
        </div>
        <div class="item-info" v-if="itemInfo">
          <p>Компания:{{itemInfo.name}}</p>
          <p>ИНН:{{itemInfo.inn}}</p>
          <button class="hover" @click="selectCompany(itemInfo)">Выбрать</button>
        </div>
      </div>

    </div>

    <!-- Этап 1: Выбор менеджера -->
    <div class="steps" v-if="currentStep === 2">
      <!-- Форма для выбора менеджера -->
      <p>Менеджер</p>
      <wizard-search 
      model="managers"
      @createItem="createManager=true"
      @selectItem="selectManager"
      v-if="!createManager"/>
      <ManagerForm v-else :companyId="companyId" @sendForm="sendForm"/>
    </div>

    <!-- Этап 2: Добавление водителя -->
    <div class="steps" v-if="currentStep === 3">
      <p>Водитель</p>
      <wizard-search 
      model="drivers"
      @createItem="createDriver=true"
      @selectItem="selectDriver"
      v-if="!createDriver"/>
      <!-- Форма для добавления водителя -->
      <DriverForm v-else @sendForm="sendForm"/>
    </div>

    <!-- Этап 3: Добавление автомобиля -->
    <div class="steps" v-if="currentStep === 4">
      <!-- Форма для выбора автомобиля -->
      <p>Автомобиль</p>
      <div v-if="!createCar">
      <wizard-search 
      model="cars"
      @createItem="createCar=true"
      @selectItem="selectCar"
      v-if="!createCar"/>
      </div>
      <CarForm v-else :company="carrierCompany" @sendForm="sendForm"/>
    </div>

    <!-- Этап 3: Добавление автомобиля -->
    <div class="steps" v-if="currentStep === 5">
      <!-- Форма для выбора автомобиля -->
      <p>Прицеп</p>
      <div>
        <wizard-search 
        model="trailers"
        @selectItem="selectTrailer"/>
      </div>
    </div>
    
      <div class="steps" v-show="currentStep === 6">
        <div v-if="carTrailerError" class="validation-error">{{ carTrailerError }}</div>
        <my-shrunk-button
          v-if="!enbMessage && !carTrailerError"
          class="create-btn"
          @click="createExecutor"
         :btnSettings="{shrunk:true}">Добавить исполнителя
        </my-shrunk-button>
        <div v-else-if="!carTrailerError" class="end-message">Исполнитель добавлен</div>
      </div>

  </div>
</template>

<script>
import { ref,computed } from 'vue';
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import ManagerForm from '@/components/forms/ManagerForm'
import DriverForm from '@/components/forms/DriverForm'
import CarForm from '@/components/forms/CarForm'
import CompanyForm from '@/components/forms/CompanyForm'
import TrailerForm from '@/components/forms/TrailerForm'

export default {
  name:'WizardExecutor',
  components: {
    ManagerForm,
    DriverForm,
    CarForm,
    CompanyForm,
    TrailerForm
  },
  props: {
    companyId: { type: [Number, String], default: null },
    /** Полная компания (name/inn) — для автозаполнения типа собственности 6. */
    company: { type: Object, default: null },
  },
  setup(props) {    
    const store = useStore()
    const route = useRoute()
    const itemInfo = ref(null)
    const createManager=ref(false)
    const createDriver=ref(false)
    const createCompany=ref(false)
    const createCar=ref(false)
    const createTrailer=ref(false)
    const selectedCompany = ref(props.company || null)

    const currentStep = ref(1); // Текущий этап мастера
    const formData = ref({}); // Место для хранения формы с введенными данными
    const startInCompany = ref(false)
    const companyId = ref(props.companyId || route.params.id)
    const enbMessage = ref(false)
    const searchList = computed(()=> store.state.apiStorage.options.company)
    const carrierCompany = computed(() => selectedCompany.value || props.company || null)

    const carTrailerError = computed(() => {
      const carId = formData.value.car_id
      const trailerId = formData.value.trailer_id
      if (carId && trailerId && carId === trailerId) {
        return 'Автомобиль и прицеп не могут быть одной записью. Вернитесь и выберите разные транспортные средства.'
      }
      return null
    })

    if(route.name == 'CompanyDetail' || props.companyId || props.company){
      startInCompany.value = true
      currentStep.value = 2
      const resolvedCompanyId = props.company?.id || props.companyId || route.params.id
      formData.value.company_id = resolvedCompanyId
      companyId.value = resolvedCompanyId
      if (props.company) {
        selectedCompany.value = props.company
      }
    }

    const goToNextStep = (newData) => {
      enbMessage.value = false
      formData.value = { ...formData.value, ...newData };
      if(newData.trailer_id){
        currentStep.value = 6;  
      }else{
        currentStep.value +=1;  
      }
      
    };

    const backStep = ()=>{
      currentStep.value -=1
      createManager.value = false
      createDriver.value = false
      createCompany.value = false
      createCar.value = false
      createTrailer.value = false
      if(currentStep.value == 3){
        
      }
    }

    const sendForm = async (data)=>{
      const response = await store.dispatch('apiStorage/addItem',data)
      if(!response) return
      if (data.model ==='cars'){
        goToNextStep({car_id:response.car_id,trailer_id:response.trailer_id})
      }else if (data.model ==='managers'){
        goToNextStep({manager_id:response.id})
      }else if (data.model ==='drivers'){
        goToNextStep({driver_id:response.id})
      }else if (data.model ==='companies'){
        companyId.value = response.id
        selectedCompany.value = {
          id: response.id,
          name: response.name || data.form?.name,
          inn: response.inn || data.form?.inn,
        }
        goToNextStep({company_id:response.id})
      }
    }

    const searchExecutors = async form =>{
      itemInfo.value = form
    }

    const selectCompany = newData =>{
      companyId.value = newData.id
      selectedCompany.value = {
        id: newData.id,
        name: newData.name,
        inn: newData.inn,
      }
      goToNextStep({company_id:newData.id})
    }

    const selectCar = newData =>{
      goToNextStep({car_id:newData.id})
    }

    const selectTrailer = newData =>{
      goToNextStep({trailer_id:newData.id})
    }

    const selectManager = newData =>{
      goToNextStep({manager_id:newData.id})
    }

    const selectDriver = newData =>{
      goToNextStep({driver_id:newData.id})
    }

    const endStep = ()=>{
      enbMessage.value = false
      currentStep.value = 6
    }

    const createExecutor = async ()=>{
      const response = await store.dispatch('apiStorage/addItem',
        {model:'executors',form:formData.value})
      if(!response) return
      enbMessage.value = true
    }

    return {
      itemInfo,
      searchExecutors,
      searchList,
      enbMessage,
      companyId,
      formData,
      carrierCompany,
      selectDriver,
      selectManager,
      selectCar,
      selectTrailer,
      selectCompany,
      createManager,
      createDriver,
      createCompany,
      createCar,
      createTrailer,
      carTrailerError,
      createExecutor,
      sendForm,
      currentStep,
      startInCompany,
      backStep,
      endStep
    };
  },
};
</script>

<style scoped>
.validation-error {
  color: #dc3545;
  font-size: 13px;
  margin-bottom: 8px;
  text-align: center;
}

.next-end-btn{
  font-size: 12px;
  height: 35px;
}

.progress-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 400px; /* Максимальная ширина полосы */
  margin: 0 auto;
  padding: 10px;
}

/* Стили для каждого шага индикатора */
.progress-bar div {
  padding: 10px;
  width: 12%;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  font-weight: bold;
}

/* Стили для активного шага */
.active {
  background-color: rgb(36,137,247,0.8);
  color: #fff;
}

/* Стили для предыдущих шагов */
.prev-step {
  background-color: #98ec83;
}

.back-step-text{
  margin-right: 25px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0px 5px;
}
.back-step:hover{
  color: #eab825;
  cursor: pointer;
}

.hover:hover{
 cursor: pointer;
 background-color: #5779b7;
}
.steps{
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.steps * {
  margin-top: 5px;
}

.search-company{
  
}

.reactive-search{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.reactive-search p {
  padding: 2px 16px;
  border: 1px solid #007bff;
  border-radius: 4px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}

.item-info{
  padding: 10px;
  margin-left: 5px;
  width: 400px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
}

.item-info button{
  padding: 8px 16px;
  border: 1px solid #007bff;
  border-radius: 4px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}
</style>
